import { React, useState, useEffect, createContext, useMemo } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";

export const AgregarPromocionModal = ({ open, onClose }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [promocion, setPromocion] = useState({
        descripcion: "",
        inicio_vigencia: "",
        vigencia: ""
    });

    const guardarPromocion = () => {
        if (promocion.descripcion === "" || promocion.descripcion === null || promocion.descripcion === undefined) {
            Swal.fire({
                title: "PROMOCIONES",
                text: "Debe escribir una descripción para la promocion",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (promocion.inicio_vigencia === "" || promocion.inicio_vigencia === null || promocion.inicio_vigencia === undefined) {
            Swal.fire({
                title: "PROMOCIONES",
                text: "Debe elegir el inicio de la vigencia de la promocion",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (promocion.vigencia === "" || promocion.vigencia === null || promocion.vigencia === undefined) {
            Swal.fire({
                title: "PROMOCIONES",
                text: "Debe elegir la vigencia de la promocion",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        setLoader({ ...loader, mostrar: true });
        request
            .get(`PromocionesDisponibles/AgregarPromocion?descripcion=${promocion.descripcion}&inicio_vigencia=${promocion.inicio_vigencia}&vigencia=${promocion.vigencia}&usuario=0`)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "PROMOCIONES",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setPromocion({ ...promocion, descripcion: "" });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PROMOCIONES", JSON.stringify(error), "error");
            });
    };

    const handleDateChange = (e) => {
        setPromocion({ ...promocion, vigencia: e.target.value });
    };

    const handleDateInicioChange = (e) => {
        setPromocion({ ...promocion, inicio_vigencia: e.target.value });
    };

    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="promocion-modal-formulario">
                    <div className="promocion-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"AGREGAR ESQUEMA DE VENTA"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`promocion-modal-agregar-convenio`}>
                                    <div className="promocion-modal-agregar-convenio-container scroll-4">
                                        <TextField
                                            id="outlined-multiline-static"
                                            label="Esquema"
                                            sx={{ mt: 1 }}
                                            size="small"
                                            value={promocion.descripcion}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const regex = /^[a-zA-Z0-9ñÑ.,% ]*$/;

                                                if (regex.test(value)) {
                                                    setPromocion({
                                                        ...promocion,
                                                        descripcion: e.target.value,
                                                    });
                                                }

                                            }}
                                        />
                                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                            <TextField
                                                id="vigencia"
                                                label="Inicio de promoción"
                                                type="date"
                                                size="small"
                                                fullWidth
                                                value={promocion.inicio_vigencia}
                                                onChange={handleDateInicioChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />
                                            <TextField
                                                id="vigencia"
                                                label="Vigencia"
                                                type="date"
                                                size="small"
                                                fullWidth
                                                value={promocion.vigencia}
                                                onChange={handleDateChange}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={{
                                                    height: '40px',
                                                    '& .MuiInputBase-root': {
                                                        height: '40px',
                                                    },
                                                    '& input': {
                                                        padding: '10px',
                                                    },
                                                }}
                                            />

                                        </Box>
                                    </div>
                                    <div className="promocion-modal-buttons">
                                        <button
                                            className="promocion-modal-button-guardar"
                                            onClick={() => guardarPromocion()}
                                        >
                                            Guardar
                                        </button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>

                    </div>
                </div>
            </Modal >
        </>
    );
};